<template>
  <slot name="header_close" />
  <div :class="{ 'number-add-telegram-frame': isIndepend }">
    <div class="title">
      <span>{{ $t("dialog.add_number.title_modal") }} Telegram</span>
    </div>
    <slot name="actions" />
    <div class="content">
      <integration-select
        parentClass="number-add-telegram-frame"
        :options="selectedOptions"
        filter="telegram"
        readonly
      />
    </div>

    <button-confirm class="confirm" @click="confirmDialog">{{
      $t("dialog.add_number.button")
    }}</button-confirm>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import IntegrationSelect from "@/components/Recurring/IntegrationSelect";
import ButtonConfirm from "@/components/Recurring/ButtonConfirm";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const store = useStore();
const router = useRouter();

const selectedOptions = ref({
  title: true,
});

defineProps({
  isIndepend: {
    type: Boolean,
    default: true,
  },
});

const confirmDialog = () => {
  store.commit("closeDialog");
  store.commit("activation/SET_MESSENGER", "telegram");

  router.push({
    name: "ActivationTelegram",
  });
};
onMounted(() => {
  store.commit("activation/CLEAR_STATE");
});
</script>

<style lang="scss" scoped>
.number-add-telegram-frame {
  padding: 20px 28px 42px;
  max-width: 750px;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border-radius: 7px;
  background-color: white;

  text-align: center;
}

.title {
  text-align: center;
  font-family: Gilroy;
  font-weight: 500;

  text-transform: uppercase;

  color: var(--text-color);

  span {
    font-size: 20px;
  }
}

.content {
  margin-top: 20px;

  display: flex;
  flex-direction: column;
  gap: 30px;

  text-align: left;
}

.confirm {
  margin-top: 16px;
}
</style>
